import type {
  FillTitleProperties,
  FillTitleType,
  FormElement,
  TableProperties,
} from '../model/form.types';

export const FILL_TITLE_TYPES: FillTitleType[] = [
  'FIRST_TITLE',
  'SECOND_TITLE',
  'THIRD_TITLE',
  'FOURTH_TITLE',
];

export const MAX_FILL_TITLE_COUNT = 4;

function* iterateTableCellFillTitles(
  table: FormElement,
  excludeId?: string,
): Generator<FillTitleProperties> {
  const cells = (table.properties as TableProperties).cells ?? [];
  for (const row of cells) {
    for (const cell of row) {
      const content = cell.content;
      if (content?.type === 'FILL_TITLE' && content.id !== excludeId) {
        yield content.properties as FillTitleProperties;
      }
    }
  }
}

function* iterateFillTitleProperties(
  elements: ReadonlyArray<FormElement>,
  excludeId?: string,
): Generator<FillTitleProperties> {
  for (const el of elements) {
    if (el.type === 'FILL_TITLE') {
      if (el.id !== excludeId) yield el.properties as FillTitleProperties;
    } else if (el.type === 'TABLE') {
      yield* iterateTableCellFillTitles(el, excludeId);
    }
  }
}

export function countFillTitleElements(elements: ReadonlyArray<FormElement>): number {
  let count = 0;
  for (const _props of iterateFillTitleProperties(elements)) count++;
  return count;
}

export function getUsedFillTitleTypes(
  elements: ReadonlyArray<FormElement>,
  excludeId?: string,
): Set<FillTitleType> {
  const used = new Set<FillTitleType>();
  for (const props of iterateFillTitleProperties(elements, excludeId)) {
    if (props.fillTitleType) used.add(props.fillTitleType);
  }
  return used;
}

export function getNextAvailableFillTitleType(
  elements: ReadonlyArray<FormElement>,
  excludeId?: string,
): FillTitleType | undefined {
  const used = getUsedFillTitleTypes(elements, excludeId);
  return FILL_TITLE_TYPES.find((t) => !used.has(t));
}
